import { createAsyncThunk } from "@reduxjs/toolkit";
import { rdsTrack_RequestDto, rdsTrack_ResponseDto } from "../../interfaces/dtos/rdsTrack";
import { jsonToQueryString } from "../../utils/http";
import { rdsMeetingGet } from "../../utils/rds";
import { apiUrls } from "../../components/shared/apiUrls";
import { RootState } from "../store";

export const loadRdsTracks = createAsyncThunk(
    'rds/loadRdsTracks',
    async () => {
        const hrTracks = await getRdsTracksFromCategory("HR");
        const dgTracks = await getRdsTracksFromCategory("DG");

        return [...hrTracks, ...dgTracks];
    },
    {
        condition: (_, { getState }) => {
            // If we are busy loading, then don't action again
            const rootState = getState() as RootState;
            if (!rootState) { return true; }

            if (rootState.rds.loadingRdsTracks) { return false; }
            return rootState.rds.rdsTracks.length === 0;
        }
    }
);

const getRdsTracksFromCategory = async (category: string) => {
    const request: rdsTrack_RequestDto = {
        category
    };

    const params = jsonToQueryString(request);
    const response = await rdsMeetingGet<rdsTrack_ResponseDto>(
        `${apiUrls.rdsMeeting.tracks}?${params}`
    );

    return response.data;
}